export default __webpack_public_path__ + "static/media/tractor_details.0bb1410f.svg";